import HorizontalScroll from './HorizontalScroll';

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./src/components/horizontalScroll/index.jsx